import {
  CHART_DATA,
  IS_ERROR,
  IS_LOADING,
  STOCK_DETAILS_DATA,
  STOCK_DETAILS_RELOADED_TIME,
  STOCK_DETAILS_TICKER_DATA,
  STOCKS_DETAILS_SELECT_CHART_BROKER,
  STOCKS_DETAILS_SELECT_CHART_TYPE,
  STOCKS_DETAILS_SELECT_DATE_BY,
  STOCKS_DETAILS_SELECT_TICKER,
  STOCKS_DETAILS_SELECT_VIEW_BY,
} from '../../redux/StocksDetails/ActionTypes';
import { message } from 'antd';
import axios from 'axios';
import axiosOrder from '../../axios';

const reducer = (state = {
  loading: false,
  ticker: 'ADBL',
  viewBy: 'Quantity',
  resultDate: 1,
  data: [],
  reloadedTime: '',
  tickersData: [],
  stockData: {},
  error: 'Cannot Load Data',
  chartType: 'buyTotalQuantity',
  brokerNumber: '',
  chartData: {},
}, action: { type: string; data: any; message: string; }) => {
  switch (action.type) {
  case STOCK_DETAILS_TICKER_DATA:
    return {
      ...state,
      tickersData: action.data,
    }
  case STOCKS_DETAILS_SELECT_TICKER:
    return {
      ...state,
      ticker: action.data,
    }
  case CHART_DATA:
    return {
      ...state,
      chartData: action.data,
    }
  case STOCKS_DETAILS_SELECT_VIEW_BY:
    return {
      ...state,
      viewBy: action.data,
    }
  case STOCKS_DETAILS_SELECT_CHART_BROKER:
    return {
      ...state,
      brokerNumber: action.data,
    }
  case STOCKS_DETAILS_SELECT_DATE_BY:
    return {
      ...state,
      resultDate: action.data,
    }
  case STOCKS_DETAILS_SELECT_CHART_TYPE:
    return {
      ...state,
      chartType: action.data,
    }

    // for async data
  case IS_LOADING:
    return {
      ...state,
      loading: true,
    }
  case STOCK_DETAILS_DATA:
    return {
      ...state,
      loading: false,
      data: action.data,
    }
  case IS_ERROR:
    return {
      ...state,
      loading: false,
      error: action.message,
    }
  case STOCK_DETAILS_RELOADED_TIME:
    return {
      ...state,
      reloadedTime: action.data,
    }
  default:
    return state
  }
}

const getBrokerFavData = (data: any) => ({
  type: STOCK_DETAILS_DATA,
  data,
})

const getChartData = (data: any) => ({
  type: CHART_DATA,
  data,
})

const getTickerData = (data: any) => ({
  type: STOCK_DETAILS_TICKER_DATA,
  data,
})
const setReloadedTime = (data: any) => ({
  type: STOCK_DETAILS_RELOADED_TIME,
  data,
})

export const selectChartBroker = (data: any) => ({
  type: STOCKS_DETAILS_SELECT_CHART_BROKER,
  data,
})
export const changeStockDetailsHeaderState = (type: string, data: string) => ({
  type,
  data,
})

const Loading = () => ({ type: IS_LOADING })
const Error = () => ({ type: IS_ERROR })

export const loadTickerFavorites = (ticker: string,
  type: string,
  date: string,
  showLoading: boolean) => async (dispatch: (arg0: { type: string; data?: any; }) => void) => {
  if (showLoading) dispatch(Loading());
  try {
    const { data: { data, reloadedTime } } = await axiosOrder.get('/systemx/dalalstreet/getTickerWiseBrokerData',
      {
        params: {
          ticker,
          type,
          date,
        },
      });
    const initBroker = data.topBrokerBuyer[0].broker || '';
    dispatch(setReloadedTime(reloadedTime))
    dispatch(selectChartBroker(initBroker));
    dispatch(getBrokerFavData(data));
  } catch (e) {
    dispatch(Error());
  }
}

export const loadTickerFavChart = (ticker: string,
  broker: string,
  type: string) => async (dispatch: (arg0: { type: string; data: any; }) => void) => {
  try {
    const { data } = await axiosOrder.get('/systemx/dalalstreet/getBrokerFavChart', {
      params: {
        ticker,
        broker,
        type,
      },
    })
    dispatch(getChartData(data));
  } catch (ex) {
    message.error('Cannot Load Chart Data');
    dispatch(getChartData([]));
  }
}

const envVar = (typeof window._env_ !== 'undefined') ? window._env_ : process.env;
export const loadTickerList = () => async (dispatch: (arg0: { type: string; data: any; }) => void) => {
  try {
    const { data } = await axios.get(`${envVar.REACT_APP_MAINENDPOINT}/tickers`);
    dispatch(getTickerData(data.data));
  } catch (e) {
    console.log(e);
    message.error('Cannot load Ticker List. Try again');
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/StocksDetails/StocksDetails.ts